import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import {
  ORIENTATION_NOTE_MAX_LENGTH,
  orientationNoteKeySchema,
  orientationNotesReplySchema,
} from "@bindery/shared/contracts/orientation-secure";
import * as z from "zod";
import { ORIENTATION_API_PREFIX } from "./errors";

export const NOTES_PATH = `${ORIENTATION_API_PREFIX}/notes`;
export const NOTES_LIST_PATH = `${ORIENTATION_API_PREFIX}/notes/list`;

/** An empty body clears the note. */
export const writeNoteRequestSchema = z.strictObject({
  sessionId: z.string().regex(UUID_REGEX),
  note: orientationNoteKeySchema,
  body: z.string().max(ORIENTATION_NOTE_MAX_LENGTH),
});
export type WriteNoteRequest = z.infer<typeof writeNoteRequestSchema>;

export const writeNoteResponseSchema = z.object({ saved: z.literal(true) });

export const listNotesRequestSchema = z.strictObject({
  sessionId: z.string().regex(UUID_REGEX),
});
export type ListNotesRequest = z.infer<typeof listNotesRequestSchema>;

export const listNotesResponseSchema = orientationNotesReplySchema;
export type ListNotesResponse = z.infer<typeof listNotesResponseSchema>;
